/* eslint-disable unused-imports/no-unused-vars */
export const MockSmooch = {
  getConversationById: async () => Promise.resolve({}),
  init: async (_args: any) => Promise.resolve({}),
  login: async (_args: any) => Promise.resolve({}),
  getConversations: async () => Promise.resolve([]),
  sendMessage: async (_message: string, _conversation_id: string) => Promise.resolve({}),
  createConversation: async (_args: any) => Promise.resolve({}),
};
